import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Sticky from "react-stickynode";
import Nav from "src/Layout/AppNav/VerticalNavWrapper";

export default function AppSidebar() {
  return (
    <div className="app-sidebar">
      <div role="presentation" className="sidebar-mobile-overlay" />
      <PerfectScrollbar
        options={{
          wheelPropagation: false,
          suppressScrollX: true,
        }}
      >
        <Sticky top=".app-header">
          <div className="app-sidebar__inner app-sidebar__no-transition">
            <Nav />
          </div>
        </Sticky>
      </PerfectScrollbar>
      <div className="app-sidebar-bg" />
    </div>
  );
}
